import React, { useEffect, useState } from "react";
import { api } from "../lib/api";
import { card, Btn, Modal, Field, Input, Select, Badge } from "./ui";
import { Plus, Pencil, Trash2 } from "lucide-react";

const ROLES = ["super_admin", "admin", "operations_manager", "branch_manager", "event_manager", "kitchen_manager", "staff", "viewer"];

export default function Staff() {
  const [rows, setRows] = useState([]);
  const [modal, setModal] = useState(null);
  const load = () => api.get("/admin/users").then(({ data }) => setRows(data)).catch(() => {});
  useEffect(() => { load(); }, []);
  const save = async (u) => {
    if (u.id) await api.put(`/admin/users/${u.id}`, u);
    else await api.post("/admin/users", u);
    setModal(null); load();
  };
  const del = async (id) => { if (!window.confirm("Remove this staff member?")) return; try { await api.delete(`/admin/users/${id}`); load(); } catch (e) { alert(e.response?.data?.detail || "Failed"); } };
  return (
    <div data-testid="admin-staff">
      <div className="flex items-center justify-between mb-6">
        <div><p className="text-gold/70 text-xs tracking-[0.25em] uppercase">Staff & Roles</p><h1 className="font-serif text-4xl text-ivory mt-1">Team</h1></div>
        <Btn onClick={() => setModal({ role: "staff" })} data-testid="add-staff"><Plus className="w-4 h-4" /> Add Staff</Btn>
      </div>
      <div className={`${card} overflow-hidden`}>
        <table className="w-full text-sm">
          <thead><tr className="text-ivory/40 text-left text-xs uppercase tracking-wider border-b border-white/5"><th className="p-3.5">Name</th><th className="p-3.5">Email</th><th className="p-3.5">Role</th><th className="p-3.5">Provider</th><th className="p-3.5 text-right">Actions</th></tr></thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.id} className="border-b border-white/5 hover:bg-white/5">
                <td className="p-3.5 text-ivory">{u.name}</td>
                <td className="p-3.5 text-ivory/60">{u.email}</td>
                <td className="p-3.5"><Badge>{u.role?.replace(/_/g, " ")}</Badge></td>
                <td className="p-3.5 text-ivory/50 text-xs">{u.auth_provider || "password"}</td>
                <td className="p-3.5"><div className="flex justify-end gap-1"><button onClick={() => setModal(u)} className="text-ivory/40 hover:text-gold p-1.5"><Pencil className="w-4 h-4" /></button><button onClick={() => del(u.id)} className="text-ivory/40 hover:text-red-400 p-1.5"><Trash2 className="w-4 h-4" /></button></div></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      <UserModal data={modal} onClose={() => setModal(null)} onSave={save} />
    </div>
  );
}

function UserModal({ data, onClose, onSave }) {
  const [f, setF] = useState({});
  useEffect(() => { setF(data || {}); }, [data]);
  if (!data) return null;
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  return (
    <Modal open onClose={onClose} title={f.id ? "Edit Staff" : "New Staff"}>
      <Field label="Name"><Input value={f.name || ""} onChange={set("name")} /></Field>
      <Field label="Email"><Input type="email" value={f.email || ""} onChange={set("email")} disabled={!!f.id} /></Field>
      <Field label={f.id ? "New Password (optional)" : "Password"}><Input type="password" value={f.password || ""} onChange={set("password")} placeholder="••••••" /></Field>
      <Field label="Role"><Select value={f.role || "staff"} onChange={set("role")} options={ROLES.map((r) => ({ value: r, label: r.replace(/_/g, " ") }))} /></Field>
      <Btn onClick={() => onSave(f)} className="w-full justify-center mt-2" data-testid="save-staff">Save</Btn>
    </Modal>
  );
}
